import { render, staticRenderFns } from "./CaptionEditor.vue?vue&type=template&id=f44a6a8e&scoped=true&"
import script from "./CaptionEditor.vue?vue&type=script&lang=js&"
export * from "./CaptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./CaptionEditor.vue?vue&type=style&index=0&id=f44a6a8e&lang=css&scoped=true&"
import style1 from "./CaptionEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44a6a8e",
  null
  
)

export default component.exports